/* eslint-disable import/prefer-default-export */
import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = '/recaudacion/asignaciones-de-placas/';

/** GET Placas
  @param {Object} params
*/
export const getAsignacionDePlacas = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/** POST Placas
 * @param {Object} values
  */
export const postAsignacionDePlacas = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Placa asignada correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/** PATCH Asignacion de plavas
 * @param {Object} values
 * @param {Number} id
 * @returns {Array} response
 */
export const patchAsignacionDePlacas = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}/`, values);
    onSuccess(response, 'Placa actualizada correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/** DELETE Asignacion de placas
 * @param {Number} id
 * */
export const deleteAsignacionDePlacas = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}/`);
    onSuccess(response, 'Placa eliminada correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
